export const RECENT_SEARCHES_KEY = "dsa5_recent_searches"
const MAX_RECENT = 5
const MIN_TERM_LENGTH = 2

export function getRecentSearches(storage = localStorage) {
  try {
    return JSON.parse(storage.getItem(RECENT_SEARCHES_KEY) || "[]")
  } catch {
    return []
  }
}

export function saveRecentSearch(term, storage = localStorage) {
  if (!term || term.length < MIN_TERM_LENGTH) return

  let recent = getRecentSearches(storage)
  recent = [term, ...recent.filter((t) => t.toLowerCase() !== term.toLowerCase())].slice(0, MAX_RECENT)

  try {
    storage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recent))
  } catch {
    // localStorage might be unavailable
  }
}
